import { useNavigate } from 'react-router';
import { getStartUrl } from '../utils/environment';
import { useCountries } from '../hooks/useCountries';
import LogoIcon from './LogoIcon';
import {
  CopyText,
  InnerFooter,
  Link,
  LinkWrapper,
  LowerFooter,
  StyledFooter,
  UpperFooter,
} from './styles';

const termsAndConditionsLinks = {
  SE: 'https://www.stenarecycling.com/sv/om-oss/Publikationer/allmanna-bestammelser/',
} as const;

type FooterProps = {
  text: {
    support: string;
    privacyInformation: string;
    releaseNotes: string;
    termsAndConditions: string;
  };
  /** defaults to 48px */
  marginTop?: string;
};

export const Footer = ({ text }: FooterProps) => {
  //Remove this when all the projects imports the language files in i18next.init instead to avoid the key flickering
  const supportTextIsLoaded = text.support !== 'footer.customer.support';
  const privacyInformationIsLoaded = text.privacyInformation !== 'footer.privacy.information';
  const releaseNotesTextIsLoaded = text.releaseNotes !== 'footer.release.notes';
  const termsAndConditionsIsLoaded = text.termsAndConditions !== 'footer.terms.and.conditions';

  const { supportedCountries, supportedCountryCodes } = useCountries();
  const isMultiMarket = supportedCountryCodes.length > 1;

  const navigate = useNavigate();

  const onContactSupportClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    void navigate('/support');
  };

  const onReleaseNotesClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    void navigate('/support/release-notes');
  };

  return (
    <StyledFooter>
      <UpperFooter>
        <InnerFooter>
          <LogoIcon />
          <LinkWrapper>
            <Link onClick={onContactSupportClick} href={`${getStartUrl()}support`}>
              {supportTextIsLoaded ? text.support : ''}
            </Link>
            <Link onClick={onReleaseNotesClick} href={`${getStartUrl()}support/release-notes`}>
              {releaseNotesTextIsLoaded ? text.releaseNotes : ''}
            </Link>
            {supportedCountries.sweden && termsAndConditionsIsLoaded && (
              <Link target="_blank" rel="noopener noreferrer" href={termsAndConditionsLinks.SE}>
                {text.termsAndConditions}
                {isMultiMarket ? ' (SE)' : ''}
              </Link>
            )}
            <Link
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.stenarecycling.com/privacy/privacy-information/"
            >
              {privacyInformationIsLoaded ? text.privacyInformation : ''}
            </Link>
          </LinkWrapper>
        </InnerFooter>
      </UpperFooter>
      <LowerFooter>
        <InnerFooter>
          <CopyText>Copyright © Stena Recycling AB</CopyText>
        </InnerFooter>
      </LowerFooter>
    </StyledFooter>
  );
};
